
import { supabase } from "@/integrations/supabase/client";

// Function to update a list's background
export const updateListBackground = async (listId: string, backgroundGradient: string): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from('shopping_lists')
      .update({ 
        background_gradient: backgroundGradient,
        updated_at: new Date().toISOString()
      })
      .eq('id', listId);

    if (error) {
      console.error(`Error updating list background ${listId}:`, error);
      return false;
    }

    return true;
  } catch (err) {
    console.error(`General error updating list background ${listId}:`, err);
    return false;
  }
};
